import { Reveal } from "@/components/Reveal";
import { ShieldCheck, BadgeCheck, Scale, Radio } from "lucide-react";

const BADGES = [
  { icon: ShieldCheck, title: "Official ASCAP® Member", sub: "Performance rights protected" },
  { icon: BadgeCheck, title: "PRO Affiliated", sub: "Publishing tracked & collected" },
  { icon: Scale, title: "Registered LLC™", sub: "DGE: Cold-Blooded Records LLC™" },
  { icon: Radio, title: "Est. 2026", sub: "New school. Real standards." },
];

const BARS = [0.5, 0.9, 0.35, 1, 0.6, 0.8, 0.45, 0.95, 0.55, 0.75, 0.4, 0.85, 0.5, 1, 0.65, 0.9, 0.4, 0.7, 0.55, 0.95, 0.45, 0.8, 0.6, 0.9];

export const TrustBadges = () => (
  <section id="affiliations" className="relative py-16 lg:py-20 border-y border-crystal/20 bg-obsidian" data-testid="trust-badges-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <Reveal className="text-center">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-venom font-medium">
          Credibility
        </p>
        <h2 className="mt-3 font-display text-xl sm:text-2xl lg:text-3xl font-bold text-white tracking-tight">
          Official ASCAP® &amp; PRO Members
        </h2>
        <div className="mt-6 flex items-end justify-center gap-[3px] h-10" aria-hidden="true">
          {BARS.map((h, i) => (
            <span
              key={i}
              className={`eq-bar w-[3px] rounded-full ${i % 3 === 0 ? "bg-venom/70" : "bg-crystal/70"}`}
              style={{ height: `${h * 100}%`, animationDelay: `${(i % 7) * 0.12}s` }}
            />
          ))}
        </div>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 auto-rows-fr gap-4 sm:gap-6">
        {BADGES.map((b, i) => {
          const Icon = b.icon;
          return (
            <Reveal key={b.title} delay={i * 0.08} className="h-full">
              <div
                className="group h-full bg-charcoal border border-crystal/20 rounded-xl px-5 py-6 text-center hover:border-venom/60 hover:-translate-y-1 hover:glow-venom transition-all duration-400"
                data-testid={`trust-badge-${i}`}
              >
                <Icon size={26} className="mx-auto text-venom mb-3" />
                <p className="font-display text-white text-xs sm:text-sm font-bold">{b.title}</p>
                <p className="mt-1.5 text-[11px] sm:text-xs text-ice/55">{b.sub}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
